// 禁用
const STATUS_DISABLE = 0
// 启用
const STATUS_ENABLE = 1
// 状态Map包括样式
const STATUS_MAP = {
  0: {
    text: '禁用',
    type: 'danger'
  },
  1: {
    text: '启用',
    type: 'success'
  },
  2: {
    text: '...',
    type: 'info'
  }
}

const REGISTER_MAP = {
  0: {
    text: '注册',
    type: 'success'
  },
  1: {
    text: '注销',
    type: 'danger'
  },
  2: {
    text: '...',
    type: 'info'
  }
}
// 0待审核、1审核中、2审核通过、3审核未通过 4:已撤回
const APPROVAL_MAP = {
  0: {
    text: '待审核',
    type: 'danger'
  },
  1: {
    text: '审核中',
    type: 'danger'
  },
  2: {
    text: '审核通过',
    type: 'success'
  },
  3: {
    text: '审核未通过',
    type: 'danger'
  },
  4: {
    text: '已撤回',
    type: 'info'
  }
}

export default {
  STATUS_DISABLE,
  STATUS_ENABLE,
  STATUS_MAP,
  REGISTER_MAP,
  APPROVAL_MAP
}
